const filterReconFields = [
    {
        name: 'match_id',
        refId: 'match_id',
        fieldName: 'match_id',
        label: 'Match Id',
        type: 'String',
        fieldType: 'String'
    },
    {
        name: 'comments',
        refId: 'comments',
        fieldName: 'comments',
        label: 'Comments',
        type: 'String',
        fieldType: 'String'
    },
    {
        name: 'label',
        refId: 'label',
        fieldName: 'label',
        label: 'Label',
        type: 'String',
        fieldType: 'String',
    },
    {
        name: 'match_status',
        refId: 'match_status',
        fieldName: 'match_status',
        label: 'Match Status',
        type: 'String',
        fieldType: 'String'
    },
    {
        name: 'created_date',
        refId: 'created_date',
        fieldName: 'created_date',
        label: 'Created Date',
        type: 'Date',
        fieldType: 'Date'
    },
    {
        name: 'last_modified_date',
        refId: 'last_modified_date',
        fieldName: 'last_modified_date',
        label: 'Last Modified Date',
        type: 'Date',
        fieldType: 'Date'
    },
    {
        name: 'last_modified_by',
        refId: 'last_modified_by',
        fieldName: 'last_modified_by',
        label: 'Last Modified By',
        type: 'String',
        fieldType: 'String'
    },
    {
        name: 'side_name',
        refId: 'side_name',
        fieldName: 'side_name',
        label: 'Side Name',
        type: 'String',
        fieldType: 'String',
    },
];

export default filterReconFields;